var contextLinkThemeNative = {
  backgroundColor: 'background.secondary',
  rightIconColor: 'text.disabled',
  leftIconColor: 'text',
  iconLeftMargin: 0,
  iconRightMargin: 0,
  divider: {
    height: 1,
    // NOTE Ad-hoc style changes, was light earlier
    color: 'border.inactive'
  },
  text: {
    color: 'text',
    size: 20
  }
};

export { contextLinkThemeNative };
